import { Info, Panel, Table } from '@elotech/components';
import React from 'react';

import { EnglobamentoItbiItem } from '../../../type';

type Props = {
  englobados: EnglobamentoItbiItem[];
  cadastroSelecionado?: number;
  cadastroPai?: number;
};

const EnglobadosList: React.FC<Props> = ({
  englobados,
  cadastroSelecionado,
  cadastroPai
}) => {
  if (!englobados || englobados.length === 0) {
    return null;
  }

  const selecionouFilho =
    cadastroSelecionado != null &&
    cadastroPai != null &&
    cadastroSelecionado !== cadastroPai;

  return (
    <>
      {selecionouFilho && (
        <Info type="primary" beaty>
          {`O cadastro ${cadastroSelecionado} faz parte de um englobamento. O cadastro Pai é ${cadastroPai}; a declaração contemplará todos os cadastros vinculados.`}
        </Info>
      )}
      <Panel title="Cadastros Englobados" isTable>
        <Table
          fixed
          values={englobados}
          keyExtractor={item => item.cadastroGeral}
        >
          <Table.Column<EnglobamentoItbiItem>
            header="Cadastro"
            value={item => item.cadastroGeral}
          />
          <Table.Column<EnglobamentoItbiItem>
            header="Inscrição"
            value={item => item.inscricaoCadastral}
          />
          <Table.Column<EnglobamentoItbiItem>
            header="Endereço"
            value={item => item.endereco}
          />
          <Table.Column<EnglobamentoItbiItem>
            header="Cadastro Pai"
            value={item => (item.pai ? 'Sim' : 'Não')}
          />
        </Table>
      </Panel>
    </>
  );
};

export default EnglobadosList;
